/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AuthedRouteRouteImport } from './routes/_authed/route';
import { Route as errorsNotFoundRouteImport } from './routes/(errors)/not-found';
import { Route as publicFirstLoginRouteImport } from './routes/(public)/first-login';
import { Route as publicForgotPasswordRouteImport } from './routes/(public)/forgot-password';
import { Route as publicLoginRouteImport } from './routes/(public)/login';
import { Route as publicLogoutRouteImport } from './routes/(public)/logout';
import { Route as publicPrivacyRouteImport } from './routes/(public)/privacy';
import { Route as publicResetPasswordRouteImport } from './routes/(public)/reset-password';
import { Route as publicSessionExpiredRouteImport } from './routes/(public)/session-expired';
import { Route as AuthedIndexRouteImport } from './routes/_authed/index';
import { Route as AuthedAdminRouteRouteImport } from './routes/_authed/_admin/route';
import { Route as AuthedFulfillmentRouteImport } from './routes/_authed/fulfillment';
import { Route as AuthedHelpRouteImport } from './routes/_authed/help';
import { Route as AuthedProfileRouteImport } from './routes/_authed/profile';
import { Route as AuthedStoreEventsRouteRouteImport } from './routes/_authed/store-events/route';
import { Route as publicFirstLoginFormRouteImport } from './routes/(public)/first-login_.form';
import { Route as publicResetPasswordFormRouteImport } from './routes/(public)/reset-password_.form';
import { Route as AuthedAdminManageRouteImport } from './routes/_authed/_admin/manage';
import { Route as AuthedCartIndexRouteImport } from './routes/_authed/cart/index';
import { Route as AuthedCartStepsRouteImport } from './routes/_authed/cart/_steps';
import { Route as AuthedFulfillmentAddRouteImport } from './routes/_authed/fulfillment_.add';
import { Route as AuthedOrdersPoNumberRouteImport } from './routes/_authed/orders.$poNumber';
import { Route as AuthedOrdersRecurringRouteImport } from './routes/_authed/orders.recurring';
import { Route as AuthedOrdersSearchRouteImport } from './routes/_authed/orders.search';
import { Route as AuthedReportsBackordersRouteImport } from './routes/_authed/reports/backorders';
import { Route as AuthedReportsBudgetsRouteImport } from './routes/_authed/reports/budgets';
import { Route as AuthedStoreEventsIndexRouteImport } from './routes/_authed/store-events/index';
import { Route as AuthedStoreEventsStepsRouteImport } from './routes/_authed/store-events/_steps';
import { Route as AuthedAdminApprovalsOrdersRouteImport } from './routes/_authed/_admin/approvals.orders';
import { Route as AuthedAdminContentAnnouncementsRouteImport } from './routes/_authed/_admin/content.announcements';
import { Route as AuthedAdminContentFaqRouteImport } from './routes/_authed/_admin/content.faq';
import { Route as AuthedAdminContentFileManagerRouteImport } from './routes/_authed/_admin/content.file-manager';
import { Route as AuthedAdminDistroHistoryRouteImport } from './routes/_authed/_admin/distro.history';
import { Route as AuthedAdminManageCalendarsRouteImport } from './routes/_authed/_admin/manage.calendars';
import { Route as AuthedAdminManageCategoriesRouteImport } from './routes/_authed/_admin/manage.categories';
import { Route as AuthedAdminManageFeaturedProductsRouteImport } from './routes/_authed/_admin/manage.featured-products';
import { Route as AuthedAdminManageKeywordsRouteImport } from './routes/_authed/_admin/manage.keywords';
import { Route as AuthedAdminManageMarketsRouteImport } from './routes/_authed/_admin/manage.markets';
import { Route as AuthedAdminManagePlantsRouteImport } from './routes/_authed/_admin/manage.plants';
import { Route as AuthedAdminManageProductsRouteImport } from './routes/_authed/_admin/manage.products';
import { Route as AuthedAdminManageQueueMessageRouteImport } from './routes/_authed/_admin/manage.queue-message';
import { Route as AuthedAdminManageStoresRouteImport } from './routes/_authed/_admin/manage.stores';
import { Route as AuthedAdminManageUsersRouteImport } from './routes/_authed/_admin/manage.users';
import { Route as AuthedAdminManageVintagesRouteImport } from './routes/_authed/_admin/manage.vintages';
import { Route as AuthedAdminReportsActivityLogRouteImport } from './routes/_authed/_admin/reports/activity-log';
import { Route as AuthedAdminReportsEmailsRouteImport } from './routes/_authed/_admin/reports/emails';
import { Route as AuthedAdminReportsProductSearchHistoryRouteImport } from './routes/_authed/_admin/reports/product-search-history';
import { Route as AuthedAdminReportsProductsRouteImport } from './routes/_authed/_admin/reports/products';
import { Route as AuthedAdminReportsSupportRequestsRouteImport } from './routes/_authed/_admin/reports/supportRequests';
import { Route as AuthedAdminReportsUsersRouteImport } from './routes/_authed/_admin/reports/users';
import { Route as AuthedCartStepsProductsRouteImport } from './routes/_authed/cart/_steps.products';
import { Route as AuthedCartStepsQuantitiesRouteImport } from './routes/_authed/cart/_steps.quantities';
import { Route as AuthedCartStepsStoresRouteImport } from './routes/_authed/cart/_steps.stores';
import { Route as AuthedCartStepsSubmitRouteImport } from './routes/_authed/cart/_steps.submit';
import { Route as AuthedCartConfirmationSalesOrderNumberRouteImport } from './routes/_authed/cart/confirmation.$salesOrderNumber';
import { Route as AuthedOrdersRecurringIdRouteImport } from './routes/_authed/orders.recurring_.$id';
import { Route as AuthedOrdersRecurringAddRouteImport } from './routes/_authed/orders.recurring_.add';
import { Route as AuthedStoreEventsStoreEventIdShipmentReportRouteImport } from './routes/_authed/store-events/$storeEventId.shipment-report';
import { Route as AuthedStoreEventsStepsStoreEventIdRouteImport } from './routes/_authed/store-events/_steps.$storeEventId';
import { Route as AuthedStoreEventsStepsNewRouteImport } from './routes/_authed/store-events/_steps.new';
import { Route as AuthedStoresStoreCodeBudgetRouteImport } from './routes/_authed/stores_.$storeCode.budget';
import { Route as AuthedAdminApprovalsOrdersPoNumberRouteImport } from './routes/_authed/_admin/approvals.orders_.$poNumber';
import { Route as AuthedAdminContentAnnouncementsAnnouncementIdRouteImport } from './routes/_authed/_admin/content.announcements_.$announcementId';
import { Route as AuthedAdminContentAnnouncementsAddRouteImport } from './routes/_authed/_admin/content.announcements_.add';
import { Route as AuthedAdminContentFaqFaqIdRouteImport } from './routes/_authed/_admin/content.faq_.$faqId';
import { Route as AuthedAdminContentFaqAddRouteImport } from './routes/_authed/_admin/content.faq_.add';
import { Route as AuthedAdminContentFileManagerDetailRouteImport } from './routes/_authed/_admin/content.file-manager_.detail';
import { Route as AuthedAdminContentFileManagerUploadRouteImport } from './routes/_authed/_admin/content.file-manager_.upload';
import { Route as AuthedAdminManageCalendarsFiscalYearRouteImport } from './routes/_authed/_admin/manage.calendars_.$fiscalYear';
import { Route as AuthedAdminManageCalendarsAddRouteImport } from './routes/_authed/_admin/manage.calendars_.add';
import { Route as AuthedAdminManageCategoriesCategoryIdRouteImport } from './routes/_authed/_admin/manage.categories_.$categoryId';
import { Route as AuthedAdminManageCategoriesAddRouteImport } from './routes/_authed/_admin/manage.categories_.add';
import { Route as AuthedAdminManageKeywordsKeywordIdRouteImport } from './routes/_authed/_admin/manage.keywords_.$keywordId';
import { Route as AuthedAdminManageKeywordsAddRouteImport } from './routes/_authed/_admin/manage.keywords_.add';
import { Route as AuthedAdminManageMarketsMarketIdRouteImport } from './routes/_authed/_admin/manage.markets_.$marketId';
import { Route as AuthedAdminManageMarketsAddRouteImport } from './routes/_authed/_admin/manage.markets_.add';
import { Route as AuthedAdminManagePlantsWarehouseLocationIdRouteImport } from './routes/_authed/_admin/manage.plants_.$warehouseLocationId';
import { Route as AuthedAdminManageProductsItemIdRouteImport } from './routes/_authed/_admin/manage.products_.$itemId';
import { Route as AuthedAdminManageProductsAddRouteImport } from './routes/_authed/_admin/manage.products_.add';
import { Route as AuthedAdminManageQueueMessageMessageIdRouteImport } from './routes/_authed/_admin/manage.queue-message_.$messageId';
import { Route as AuthedAdminManageStoresStoreCodeRouteImport } from './routes/_authed/_admin/manage.stores_.$storeCode';
import { Route as AuthedAdminManageStoresAddRouteImport } from './routes/_authed/_admin/manage.stores_.add';
import { Route as AuthedAdminManageUsersUserNameRouteImport } from './routes/_authed/_admin/manage.users_.$userName';
import { Route as AuthedAdminManageUsersAddRouteImport } from './routes/_authed/_admin/manage.users_.add';
import { Route as AuthedAdminManageVintagesVintageIdRouteImport } from './routes/_authed/_admin/manage.vintages_.$vintageId';
import { Route as AuthedAdminManageVintagesAddRouteImport } from './routes/_authed/_admin/manage.vintages_.add';
import { Route as AuthedAdminReportsEmailsEmailIdRouteImport } from './routes/_authed/_admin/reports/emails_.$emailId';
import { Route as AuthedStoreEventsStepsStoreEventIdCategoriesRouteImport } from './routes/_authed/store-events/_steps.$storeEventId.categories';
import { Route as AuthedStoreEventsStepsStoreEventIdDetailsRouteImport } from './routes/_authed/store-events/_steps.$storeEventId.details';
import { Route as AuthedStoreEventsStepsStoreEventIdProductsRouteImport } from './routes/_authed/store-events/_steps.$storeEventId.products';
import { Route as AuthedStoreEventsStepsStoreEventIdIndexRouteImport } from './routes/_authed/store-events/_steps_.$storeEventId.index';
import { Route as AuthedAdminManageQueueMessageQueueStatusRouteImport } from './routes/_authed/_admin/manage.queue-message_.$queue_.$status';

const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any);
const errorsNotFoundRoute = errorsNotFoundRouteImport.update({
  id: '/(errors)/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any);
const publicFirstLoginRoute = publicFirstLoginRouteImport.update({
  id: '/(public)/first-login',
  path: '/first-login',
  getParentRoute: () => rootRouteImport,
} as any);
const publicForgotPasswordRoute = publicForgotPasswordRouteImport.update({
  id: '/(public)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/(public)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const publicLogoutRoute = publicLogoutRouteImport.update({
  id: '/(public)/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any);
const publicPrivacyRoute = publicPrivacyRouteImport.update({
  id: '/(public)/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any);
const publicResetPasswordRoute = publicResetPasswordRouteImport.update({
  id: '/(public)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const publicSessionExpiredRoute = publicSessionExpiredRouteImport.update({
  id: '/(public)/session-expired',
  path: '/session-expired',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedAdminRouteRoute = AuthedAdminRouteRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedFulfillmentRoute = AuthedFulfillmentRouteImport.update({
  id: '/fulfillment',
  path: '/fulfillment',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedHelpRoute = AuthedHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedStoreEventsRouteRoute = AuthedStoreEventsRouteRouteImport.update({
  id: '/store-events',
  path: '/store-events',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const publicFirstLoginFormRoute = publicFirstLoginFormRouteImport.update({
  id: '/(public)/first-login_/form',
  path: '/first-login/form',
  getParentRoute: () => rootRouteImport,
} as any);
const publicResetPasswordFormRoute = publicResetPasswordFormRouteImport.update({
  id: '/(public)/reset-password_/form',
  path: '/reset-password/form',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedAdminManageRoute = AuthedAdminManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any);
const AuthedCartIndexRoute = AuthedCartIndexRouteImport.update({
  id: '/cart/',
  path: '/cart/',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedCartStepsRoute = AuthedCartStepsRouteImport.update({
  id: '/cart/_steps',
  path: '/cart',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedFulfillmentAddRoute = AuthedFulfillmentAddRouteImport.update({
  id: '/fulfillment_/add',
  path: '/fulfillment/add',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedOrdersPoNumberRoute = AuthedOrdersPoNumberRouteImport.update({
  id: '/orders/$poNumber',
  path: '/orders/$poNumber',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedOrdersRecurringRoute = AuthedOrdersRecurringRouteImport.update({
  id: '/orders/recurring',
  path: '/orders/recurring',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedOrdersSearchRoute = AuthedOrdersSearchRouteImport.update({
  id: '/orders/search',
  path: '/orders/search',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedReportsBackordersRoute = AuthedReportsBackordersRouteImport.update({
  id: '/reports/backorders',
  path: '/reports/backorders',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedReportsBudgetsRoute = AuthedReportsBudgetsRouteImport.update({
  id: '/reports/budgets',
  path: '/reports/budgets',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedStoreEventsIndexRoute = AuthedStoreEventsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedStoreEventsRouteRoute,
} as any);
const AuthedStoreEventsStepsRoute = AuthedStoreEventsStepsRouteImport.update({
  id: '/_steps',
  getParentRoute: () => AuthedStoreEventsRouteRoute,
} as any);
const AuthedAdminApprovalsOrdersRoute =
  AuthedAdminApprovalsOrdersRouteImport.update({
    id: '/approvals/orders',
    path: '/approvals/orders',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentAnnouncementsRoute =
  AuthedAdminContentAnnouncementsRouteImport.update({
    id: '/content/announcements',
    path: '/content/announcements',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentFaqRoute = AuthedAdminContentFaqRouteImport.update({
  id: '/content/faq',
  path: '/content/faq',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any);
const AuthedAdminContentFileManagerRoute =
  AuthedAdminContentFileManagerRouteImport.update({
    id: '/content/file-manager',
    path: '/content/file-manager',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminDistroHistoryRoute =
  AuthedAdminDistroHistoryRouteImport.update({
    id: '/distro/history',
    path: '/distro/history',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminManageCalendarsRoute =
  AuthedAdminManageCalendarsRouteImport.update({
    id: '/calendars',
    path: '/calendars',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCategoriesRoute =
  AuthedAdminManageCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageFeaturedProductsRoute =
  AuthedAdminManageFeaturedProductsRouteImport.update({
    id: '/featured-products',
    path: '/featured-products',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageKeywordsRoute =
  AuthedAdminManageKeywordsRouteImport.update({
    id: '/keywords',
    path: '/keywords',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageMarketsRoute =
  AuthedAdminManageMarketsRouteImport.update({
    id: '/markets',
    path: '/markets',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManagePlantsRoute = AuthedAdminManagePlantsRouteImport.update({
  id: '/plants',
  path: '/plants',
  getParentRoute: () => AuthedAdminManageRoute,
} as any);
const AuthedAdminManageProductsRoute =
  AuthedAdminManageProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageQueueMessageRoute =
  AuthedAdminManageQueueMessageRouteImport.update({
    id: '/queue-message',
    path: '/queue-message',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageStoresRoute = AuthedAdminManageStoresRouteImport.update({
  id: '/stores',
  path: '/stores',
  getParentRoute: () => AuthedAdminManageRoute,
} as any);
const AuthedAdminManageUsersRoute = AuthedAdminManageUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedAdminManageRoute,
} as any);
const AuthedAdminManageVintagesRoute =
  AuthedAdminManageVintagesRouteImport.update({
    id: '/vintages',
    path: '/vintages',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminReportsActivityLogRoute =
  AuthedAdminReportsActivityLogRouteImport.update({
    id: '/reports/activity-log',
    path: '/reports/activity-log',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsEmailsRoute =
  AuthedAdminReportsEmailsRouteImport.update({
    id: '/reports/emails',
    path: '/reports/emails',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsProductSearchHistoryRoute =
  AuthedAdminReportsProductSearchHistoryRouteImport.update({
    id: '/reports/product-search-history',
    path: '/reports/product-search-history',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsProductsRoute =
  AuthedAdminReportsProductsRouteImport.update({
    id: '/reports/products',
    path: '/reports/products',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsSupportRequestsRoute =
  AuthedAdminReportsSupportRequestsRouteImport.update({
    id: '/reports/supportRequests',
    path: '/reports/supportRequests',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminReportsUsersRoute = AuthedAdminReportsUsersRouteImport.update({
  id: '/reports/users',
  path: '/reports/users',
  getParentRoute: () => AuthedAdminRouteRoute,
} as any);
const AuthedCartStepsProductsRoute = AuthedCartStepsProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AuthedCartStepsRoute,
} as any);
const AuthedCartStepsQuantitiesRoute =
  AuthedCartStepsQuantitiesRouteImport.update({
    id: '/quantities',
    path: '/quantities',
    getParentRoute: () => AuthedCartStepsRoute,
  } as any);
const AuthedCartStepsStoresRoute = AuthedCartStepsStoresRouteImport.update({
  id: '/stores',
  path: '/stores',
  getParentRoute: () => AuthedCartStepsRoute,
} as any);
const AuthedCartStepsSubmitRoute = AuthedCartStepsSubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => AuthedCartStepsRoute,
} as any);
const AuthedCartConfirmationSalesOrderNumberRoute =
  AuthedCartConfirmationSalesOrderNumberRouteImport.update({
    id: '/cart/confirmation/$salesOrderNumber',
    path: '/cart/confirmation/$salesOrderNumber',
    getParentRoute: () => AuthedRouteRoute,
  } as any);
const AuthedOrdersRecurringIdRoute = AuthedOrdersRecurringIdRouteImport.update({
  id: '/orders/recurring_/$id',
  path: '/orders/recurring/$id',
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedOrdersRecurringAddRoute =
  AuthedOrdersRecurringAddRouteImport.update({
    id: '/orders/recurring_/add',
    path: '/orders/recurring/add',
    getParentRoute: () => AuthedRouteRoute,
  } as any);
const AuthedStoreEventsStoreEventIdShipmentReportRoute =
  AuthedStoreEventsStoreEventIdShipmentReportRouteImport.update({
    id: '/$storeEventId/shipment-report',
    path: '/$storeEventId/shipment-report',
    getParentRoute: () => AuthedStoreEventsRouteRoute,
  } as any);
const AuthedStoreEventsStepsStoreEventIdRoute =
  AuthedStoreEventsStepsStoreEventIdRouteImport.update({
    id: '/$storeEventId',
    path: '/$storeEventId',
    getParentRoute: () => AuthedStoreEventsStepsRoute,
  } as any);
const AuthedStoreEventsStepsNewRoute =
  AuthedStoreEventsStepsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthedStoreEventsStepsRoute,
  } as any);
const AuthedStoresStoreCodeBudgetRoute =
  AuthedStoresStoreCodeBudgetRouteImport.update({
    id: '/stores_/$storeCode/budget',
    path: '/stores/$storeCode/budget',
    getParentRoute: () => AuthedRouteRoute,
  } as any);
const AuthedAdminApprovalsOrdersPoNumberRoute =
  AuthedAdminApprovalsOrdersPoNumberRouteImport.update({
    id: '/approvals/orders_/$poNumber',
    path: '/approvals/orders/$poNumber',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentAnnouncementsAnnouncementIdRoute =
  AuthedAdminContentAnnouncementsAnnouncementIdRouteImport.update({
    id: '/content/announcements_/$announcementId',
    path: '/content/announcements/$announcementId',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentAnnouncementsAddRoute =
  AuthedAdminContentAnnouncementsAddRouteImport.update({
    id: '/content/announcements_/add',
    path: '/content/announcements/add',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentFaqFaqIdRoute =
  AuthedAdminContentFaqFaqIdRouteImport.update({
    id: '/content/faq_/$faqId',
    path: '/content/faq/$faqId',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentFaqAddRoute =
  AuthedAdminContentFaqAddRouteImport.update({
    id: '/content/faq_/add',
    path: '/content/faq/add',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentFileManagerDetailRoute =
  AuthedAdminContentFileManagerDetailRouteImport.update({
    id: '/content/file-manager_/detail',
    path: '/content/file-manager/detail',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminContentFileManagerUploadRoute =
  AuthedAdminContentFileManagerUploadRouteImport.update({
    id: '/content/file-manager_/upload',
    path: '/content/file-manager/upload',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedAdminManageCalendarsFiscalYearRoute =
  AuthedAdminManageCalendarsFiscalYearRouteImport.update({
    id: '/calendars_/$fiscalYear',
    path: '/calendars/$fiscalYear',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCalendarsAddRoute =
  AuthedAdminManageCalendarsAddRouteImport.update({
    id: '/calendars_/add',
    path: '/calendars/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCategoriesCategoryIdRoute =
  AuthedAdminManageCategoriesCategoryIdRouteImport.update({
    id: '/categories_/$categoryId',
    path: '/categories/$categoryId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageCategoriesAddRoute =
  AuthedAdminManageCategoriesAddRouteImport.update({
    id: '/categories_/add',
    path: '/categories/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageKeywordsKeywordIdRoute =
  AuthedAdminManageKeywordsKeywordIdRouteImport.update({
    id: '/keywords_/$keywordId',
    path: '/keywords/$keywordId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageKeywordsAddRoute =
  AuthedAdminManageKeywordsAddRouteImport.update({
    id: '/keywords_/add',
    path: '/keywords/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageMarketsMarketIdRoute =
  AuthedAdminManageMarketsMarketIdRouteImport.update({
    id: '/markets_/$marketId',
    path: '/markets/$marketId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageMarketsAddRoute =
  AuthedAdminManageMarketsAddRouteImport.update({
    id: '/markets_/add',
    path: '/markets/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManagePlantsWarehouseLocationIdRoute =
  AuthedAdminManagePlantsWarehouseLocationIdRouteImport.update({
    id: '/plants_/$warehouseLocationId',
    path: '/plants/$warehouseLocationId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageProductsItemIdRoute =
  AuthedAdminManageProductsItemIdRouteImport.update({
    id: '/products_/$itemId',
    path: '/products/$itemId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageProductsAddRoute =
  AuthedAdminManageProductsAddRouteImport.update({
    id: '/products_/add',
    path: '/products/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageQueueMessageMessageIdRoute =
  AuthedAdminManageQueueMessageMessageIdRouteImport.update({
    id: '/queue-message_/$messageId',
    path: '/queue-message/$messageId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageStoresStoreCodeRoute =
  AuthedAdminManageStoresStoreCodeRouteImport.update({
    id: '/stores_/$storeCode',
    path: '/stores/$storeCode',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageStoresAddRoute =
  AuthedAdminManageStoresAddRouteImport.update({
    id: '/stores_/add',
    path: '/stores/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageUsersUserNameRoute =
  AuthedAdminManageUsersUserNameRouteImport.update({
    id: '/users_/$userName',
    path: '/users/$userName',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageUsersAddRoute =
  AuthedAdminManageUsersAddRouteImport.update({
    id: '/users_/add',
    path: '/users/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageVintagesVintageIdRoute =
  AuthedAdminManageVintagesVintageIdRouteImport.update({
    id: '/vintages_/$vintageId',
    path: '/vintages/$vintageId',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminManageVintagesAddRoute =
  AuthedAdminManageVintagesAddRouteImport.update({
    id: '/vintages_/add',
    path: '/vintages/add',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);
const AuthedAdminReportsEmailsEmailIdRoute =
  AuthedAdminReportsEmailsEmailIdRouteImport.update({
    id: '/reports/emails_/$emailId',
    path: '/reports/emails/$emailId',
    getParentRoute: () => AuthedAdminRouteRoute,
  } as any);
const AuthedStoreEventsStepsStoreEventIdCategoriesRoute =
  AuthedStoreEventsStepsStoreEventIdCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthedStoreEventsStepsStoreEventIdRoute,
  } as any);
const AuthedStoreEventsStepsStoreEventIdDetailsRoute =
  AuthedStoreEventsStepsStoreEventIdDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthedStoreEventsStepsStoreEventIdRoute,
  } as any);
const AuthedStoreEventsStepsStoreEventIdProductsRoute =
  AuthedStoreEventsStepsStoreEventIdProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthedStoreEventsStepsStoreEventIdRoute,
  } as any);
const AuthedStoreEventsStepsStoreEventIdIndexRoute =
  AuthedStoreEventsStepsStoreEventIdIndexRouteImport.update({
    id: '/_steps_/$storeEventId/',
    path: '/$storeEventId/',
    getParentRoute: () => AuthedStoreEventsRouteRoute,
  } as any);
const AuthedAdminManageQueueMessageQueueStatusRoute =
  AuthedAdminManageQueueMessageQueueStatusRouteImport.update({
    id: '/queue-message_/$queue_/$status',
    path: '/queue-message/$queue/$status',
    getParentRoute: () => AuthedAdminManageRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute;
  '/store-events': typeof AuthedStoreEventsRouteRouteWithChildren;
  '/not-found': typeof errorsNotFoundRoute;
  '/first-login': typeof publicFirstLoginRoute;
  '/forgot-password': typeof publicForgotPasswordRoute;
  '/login': typeof publicLoginRoute;
  '/logout': typeof publicLogoutRoute;
  '/privacy': typeof publicPrivacyRoute;
  '/reset-password': typeof publicResetPasswordRoute;
  '/session-expired': typeof publicSessionExpiredRoute;
  '/fulfillment': typeof AuthedFulfillmentRoute;
  '/help': typeof AuthedHelpRoute;
  '/profile': typeof AuthedProfileRoute;
  '/first-login/form': typeof publicFirstLoginFormRoute;
  '/reset-password/form': typeof publicResetPasswordFormRoute;
  '/manage': typeof AuthedAdminManageRouteWithChildren;
  '/cart': typeof AuthedCartStepsRouteWithChildren;
  '/fulfillment/add': typeof AuthedFulfillmentAddRoute;
  '/orders/$poNumber': typeof AuthedOrdersPoNumberRoute;
  '/orders/recurring': typeof AuthedOrdersRecurringRoute;
  '/orders/search': typeof AuthedOrdersSearchRoute;
  '/reports/backorders': typeof AuthedReportsBackordersRoute;
  '/reports/budgets': typeof AuthedReportsBudgetsRoute;
  '/cart/': typeof AuthedCartIndexRoute;
  '/store-events/': typeof AuthedStoreEventsIndexRoute;
  '/approvals/orders': typeof AuthedAdminApprovalsOrdersRoute;
  '/content/announcements': typeof AuthedAdminContentAnnouncementsRoute;
  '/content/faq': typeof AuthedAdminContentFaqRoute;
  '/content/file-manager': typeof AuthedAdminContentFileManagerRoute;
  '/distro/history': typeof AuthedAdminDistroHistoryRoute;
  '/manage/calendars': typeof AuthedAdminManageCalendarsRoute;
  '/manage/categories': typeof AuthedAdminManageCategoriesRoute;
  '/manage/featured-products': typeof AuthedAdminManageFeaturedProductsRoute;
  '/manage/keywords': typeof AuthedAdminManageKeywordsRoute;
  '/manage/markets': typeof AuthedAdminManageMarketsRoute;
  '/manage/plants': typeof AuthedAdminManagePlantsRoute;
  '/manage/products': typeof AuthedAdminManageProductsRoute;
  '/manage/queue-message': typeof AuthedAdminManageQueueMessageRoute;
  '/manage/stores': typeof AuthedAdminManageStoresRoute;
  '/manage/users': typeof AuthedAdminManageUsersRoute;
  '/manage/vintages': typeof AuthedAdminManageVintagesRoute;
  '/reports/activity-log': typeof AuthedAdminReportsActivityLogRoute;
  '/reports/emails': typeof AuthedAdminReportsEmailsRoute;
  '/reports/product-search-history': typeof AuthedAdminReportsProductSearchHistoryRoute;
  '/reports/products': typeof AuthedAdminReportsProductsRoute;
  '/reports/supportRequests': typeof AuthedAdminReportsSupportRequestsRoute;
  '/reports/users': typeof AuthedAdminReportsUsersRoute;
  '/cart/products': typeof AuthedCartStepsProductsRoute;
  '/cart/quantities': typeof AuthedCartStepsQuantitiesRoute;
  '/cart/stores': typeof AuthedCartStepsStoresRoute;
  '/cart/submit': typeof AuthedCartStepsSubmitRoute;
  '/cart/confirmation/$salesOrderNumber': typeof AuthedCartConfirmationSalesOrderNumberRoute;
  '/orders/recurring/$id': typeof AuthedOrdersRecurringIdRoute;
  '/orders/recurring/add': typeof AuthedOrdersRecurringAddRoute;
  '/store-events/$storeEventId/shipment-report': typeof AuthedStoreEventsStoreEventIdShipmentReportRoute;
  '/store-events/$storeEventId': typeof AuthedStoreEventsStepsStoreEventIdRouteWithChildren;
  '/store-events/new': typeof AuthedStoreEventsStepsNewRoute;
  '/stores/$storeCode/budget': typeof AuthedStoresStoreCodeBudgetRoute;
  '/approvals/orders/$poNumber': typeof AuthedAdminApprovalsOrdersPoNumberRoute;
  '/content/announcements/$announcementId': typeof AuthedAdminContentAnnouncementsAnnouncementIdRoute;
  '/content/announcements/add': typeof AuthedAdminContentAnnouncementsAddRoute;
  '/content/faq/$faqId': typeof AuthedAdminContentFaqFaqIdRoute;
  '/content/faq/add': typeof AuthedAdminContentFaqAddRoute;
  '/content/file-manager/detail': typeof AuthedAdminContentFileManagerDetailRoute;
  '/content/file-manager/upload': typeof AuthedAdminContentFileManagerUploadRoute;
  '/manage/calendars/$fiscalYear': typeof AuthedAdminManageCalendarsFiscalYearRoute;
  '/manage/calendars/add': typeof AuthedAdminManageCalendarsAddRoute;
  '/manage/categories/$categoryId': typeof AuthedAdminManageCategoriesCategoryIdRoute;
  '/manage/categories/add': typeof AuthedAdminManageCategoriesAddRoute;
  '/manage/keywords/$keywordId': typeof AuthedAdminManageKeywordsKeywordIdRoute;
  '/manage/keywords/add': typeof AuthedAdminManageKeywordsAddRoute;
  '/manage/markets/$marketId': typeof AuthedAdminManageMarketsMarketIdRoute;
  '/manage/markets/add': typeof AuthedAdminManageMarketsAddRoute;
  '/manage/plants/$warehouseLocationId': typeof AuthedAdminManagePlantsWarehouseLocationIdRoute;
  '/manage/products/$itemId': typeof AuthedAdminManageProductsItemIdRoute;
  '/manage/products/add': typeof AuthedAdminManageProductsAddRoute;
  '/manage/queue-message/$messageId': typeof AuthedAdminManageQueueMessageMessageIdRoute;
  '/manage/stores/$storeCode': typeof AuthedAdminManageStoresStoreCodeRoute;
  '/manage/stores/add': typeof AuthedAdminManageStoresAddRoute;
  '/manage/users/$userName': typeof AuthedAdminManageUsersUserNameRoute;
  '/manage/users/add': typeof AuthedAdminManageUsersAddRoute;
  '/manage/vintages/$vintageId': typeof AuthedAdminManageVintagesVintageIdRoute;
  '/manage/vintages/add': typeof AuthedAdminManageVintagesAddRoute;
  '/reports/emails/$emailId': typeof AuthedAdminReportsEmailsEmailIdRoute;
  '/store-events/$storeEventId/categories': typeof AuthedStoreEventsStepsStoreEventIdCategoriesRoute;
  '/store-events/$storeEventId/details': typeof AuthedStoreEventsStepsStoreEventIdDetailsRoute;
  '/store-events/$storeEventId/products': typeof AuthedStoreEventsStepsStoreEventIdProductsRoute;
  '/store-events/$storeEventId/': typeof AuthedStoreEventsStepsStoreEventIdIndexRoute;
  '/manage/queue-message/$queue/$status': typeof AuthedAdminManageQueueMessageQueueStatusRoute;
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute;
  '/not-found': typeof errorsNotFoundRoute;
  '/first-login': typeof publicFirstLoginRoute;
  '/forgot-password': typeof publicForgotPasswordRoute;
  '/login': typeof publicLoginRoute;
  '/logout': typeof publicLogoutRoute;
  '/privacy': typeof publicPrivacyRoute;
  '/reset-password': typeof publicResetPasswordRoute;
  '/session-expired': typeof publicSessionExpiredRoute;
  '/fulfillment': typeof AuthedFulfillmentRoute;
  '/help': typeof AuthedHelpRoute;
  '/profile': typeof AuthedProfileRoute;
  '/first-login/form': typeof publicFirstLoginFormRoute;
  '/reset-password/form': typeof publicResetPasswordFormRoute;
  '/manage': typeof AuthedAdminManageRouteWithChildren;
  '/cart': typeof AuthedCartIndexRoute;
  '/fulfillment/add': typeof AuthedFulfillmentAddRoute;
  '/orders/$poNumber': typeof AuthedOrdersPoNumberRoute;
  '/orders/recurring': typeof AuthedOrdersRecurringRoute;
  '/orders/search': typeof AuthedOrdersSearchRoute;
  '/reports/backorders': typeof AuthedReportsBackordersRoute;
  '/reports/budgets': typeof AuthedReportsBudgetsRoute;
  '/store-events': typeof AuthedStoreEventsIndexRoute;
  '/approvals/orders': typeof AuthedAdminApprovalsOrdersRoute;
  '/content/announcements': typeof AuthedAdminContentAnnouncementsRoute;
  '/content/faq': typeof AuthedAdminContentFaqRoute;
  '/content/file-manager': typeof AuthedAdminContentFileManagerRoute;
  '/distro/history': typeof AuthedAdminDistroHistoryRoute;
  '/manage/calendars': typeof AuthedAdminManageCalendarsRoute;
  '/manage/categories': typeof AuthedAdminManageCategoriesRoute;
  '/manage/featured-products': typeof AuthedAdminManageFeaturedProductsRoute;
  '/manage/keywords': typeof AuthedAdminManageKeywordsRoute;
  '/manage/markets': typeof AuthedAdminManageMarketsRoute;
  '/manage/plants': typeof AuthedAdminManagePlantsRoute;
  '/manage/products': typeof AuthedAdminManageProductsRoute;
  '/manage/queue-message': typeof AuthedAdminManageQueueMessageRoute;
  '/manage/stores': typeof AuthedAdminManageStoresRoute;
  '/manage/users': typeof AuthedAdminManageUsersRoute;
  '/manage/vintages': typeof AuthedAdminManageVintagesRoute;
  '/reports/activity-log': typeof AuthedAdminReportsActivityLogRoute;
  '/reports/emails': typeof AuthedAdminReportsEmailsRoute;
  '/reports/product-search-history': typeof AuthedAdminReportsProductSearchHistoryRoute;
  '/reports/products': typeof AuthedAdminReportsProductsRoute;
  '/reports/supportRequests': typeof AuthedAdminReportsSupportRequestsRoute;
  '/reports/users': typeof AuthedAdminReportsUsersRoute;
  '/cart/products': typeof AuthedCartStepsProductsRoute;
  '/cart/quantities': typeof AuthedCartStepsQuantitiesRoute;
  '/cart/stores': typeof AuthedCartStepsStoresRoute;
  '/cart/submit': typeof AuthedCartStepsSubmitRoute;
  '/cart/confirmation/$salesOrderNumber': typeof AuthedCartConfirmationSalesOrderNumberRoute;
  '/orders/recurring/$id': typeof AuthedOrdersRecurringIdRoute;
  '/orders/recurring/add': typeof AuthedOrdersRecurringAddRoute;
  '/store-events/$storeEventId/shipment-report': typeof AuthedStoreEventsStoreEventIdShipmentReportRoute;
  '/store-events/$storeEventId': typeof AuthedStoreEventsStepsStoreEventIdIndexRoute;
  '/store-events/new': typeof AuthedStoreEventsStepsNewRoute;
  '/stores/$storeCode/budget': typeof AuthedStoresStoreCodeBudgetRoute;
  '/approvals/orders/$poNumber': typeof AuthedAdminApprovalsOrdersPoNumberRoute;
  '/content/announcements/$announcementId': typeof AuthedAdminContentAnnouncementsAnnouncementIdRoute;
  '/content/announcements/add': typeof AuthedAdminContentAnnouncementsAddRoute;
  '/content/faq/$faqId': typeof AuthedAdminContentFaqFaqIdRoute;
  '/content/faq/add': typeof AuthedAdminContentFaqAddRoute;
  '/content/file-manager/detail': typeof AuthedAdminContentFileManagerDetailRoute;
  '/content/file-manager/upload': typeof AuthedAdminContentFileManagerUploadRoute;
  '/manage/calendars/$fiscalYear': typeof AuthedAdminManageCalendarsFiscalYearRoute;
  '/manage/calendars/add': typeof AuthedAdminManageCalendarsAddRoute;
  '/manage/categories/$categoryId': typeof AuthedAdminManageCategoriesCategoryIdRoute;
  '/manage/categories/add': typeof AuthedAdminManageCategoriesAddRoute;
  '/manage/keywords/$keywordId': typeof AuthedAdminManageKeywordsKeywordIdRoute;
  '/manage/keywords/add': typeof AuthedAdminManageKeywordsAddRoute;
  '/manage/markets/$marketId': typeof AuthedAdminManageMarketsMarketIdRoute;
  '/manage/markets/add': typeof AuthedAdminManageMarketsAddRoute;
  '/manage/plants/$warehouseLocationId': typeof AuthedAdminManagePlantsWarehouseLocationIdRoute;
  '/manage/products/$itemId': typeof AuthedAdminManageProductsItemIdRoute;
  '/manage/products/add': typeof AuthedAdminManageProductsAddRoute;
  '/manage/queue-message/$messageId': typeof AuthedAdminManageQueueMessageMessageIdRoute;
  '/manage/stores/$storeCode': typeof AuthedAdminManageStoresStoreCodeRoute;
  '/manage/stores/add': typeof AuthedAdminManageStoresAddRoute;
  '/manage/users/$userName': typeof AuthedAdminManageUsersUserNameRoute;
  '/manage/users/add': typeof AuthedAdminManageUsersAddRoute;
  '/manage/vintages/$vintageId': typeof AuthedAdminManageVintagesVintageIdRoute;
  '/manage/vintages/add': typeof AuthedAdminManageVintagesAddRoute;
  '/reports/emails/$emailId': typeof AuthedAdminReportsEmailsEmailIdRoute;
  '/store-events/$storeEventId/categories': typeof AuthedStoreEventsStepsStoreEventIdCategoriesRoute;
  '/store-events/$storeEventId/details': typeof AuthedStoreEventsStepsStoreEventIdDetailsRoute;
  '/store-events/$storeEventId/products': typeof AuthedStoreEventsStepsStoreEventIdProductsRoute;
  '/manage/queue-message/$queue/$status': typeof AuthedAdminManageQueueMessageQueueStatusRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_authed': typeof AuthedRouteRouteWithChildren;
  '/_authed/_admin': typeof AuthedAdminRouteRouteWithChildren;
  '/_authed/store-events': typeof AuthedStoreEventsRouteRouteWithChildren;
  '/(errors)/not-found': typeof errorsNotFoundRoute;
  '/(public)/first-login': typeof publicFirstLoginRoute;
  '/(public)/forgot-password': typeof publicForgotPasswordRoute;
  '/(public)/login': typeof publicLoginRoute;
  '/(public)/logout': typeof publicLogoutRoute;
  '/(public)/privacy': typeof publicPrivacyRoute;
  '/(public)/reset-password': typeof publicResetPasswordRoute;
  '/(public)/session-expired': typeof publicSessionExpiredRoute;
  '/_authed/fulfillment': typeof AuthedFulfillmentRoute;
  '/_authed/help': typeof AuthedHelpRoute;
  '/_authed/profile': typeof AuthedProfileRoute;
  '/_authed/': typeof AuthedIndexRoute;
  '/(public)/first-login_/form': typeof publicFirstLoginFormRoute;
  '/(public)/reset-password_/form': typeof publicResetPasswordFormRoute;
  '/_authed/_admin/manage': typeof AuthedAdminManageRouteWithChildren;
  '/_authed/cart/_steps': typeof AuthedCartStepsRouteWithChildren;
  '/_authed/fulfillment_/add': typeof AuthedFulfillmentAddRoute;
  '/_authed/orders/$poNumber': typeof AuthedOrdersPoNumberRoute;
  '/_authed/orders/recurring': typeof AuthedOrdersRecurringRoute;
  '/_authed/orders/search': typeof AuthedOrdersSearchRoute;
  '/_authed/reports/backorders': typeof AuthedReportsBackordersRoute;
  '/_authed/reports/budgets': typeof AuthedReportsBudgetsRoute;
  '/_authed/store-events/_steps': typeof AuthedStoreEventsStepsRouteWithChildren;
  '/_authed/cart/': typeof AuthedCartIndexRoute;
  '/_authed/store-events/': typeof AuthedStoreEventsIndexRoute;
  '/_authed/_admin/approvals/orders': typeof AuthedAdminApprovalsOrdersRoute;
  '/_authed/_admin/content/announcements': typeof AuthedAdminContentAnnouncementsRoute;
  '/_authed/_admin/content/faq': typeof AuthedAdminContentFaqRoute;
  '/_authed/_admin/content/file-manager': typeof AuthedAdminContentFileManagerRoute;
  '/_authed/_admin/distro/history': typeof AuthedAdminDistroHistoryRoute;
  '/_authed/_admin/manage/calendars': typeof AuthedAdminManageCalendarsRoute;
  '/_authed/_admin/manage/categories': typeof AuthedAdminManageCategoriesRoute;
  '/_authed/_admin/manage/featured-products': typeof AuthedAdminManageFeaturedProductsRoute;
  '/_authed/_admin/manage/keywords': typeof AuthedAdminManageKeywordsRoute;
  '/_authed/_admin/manage/markets': typeof AuthedAdminManageMarketsRoute;
  '/_authed/_admin/manage/plants': typeof AuthedAdminManagePlantsRoute;
  '/_authed/_admin/manage/products': typeof AuthedAdminManageProductsRoute;
  '/_authed/_admin/manage/queue-message': typeof AuthedAdminManageQueueMessageRoute;
  '/_authed/_admin/manage/stores': typeof AuthedAdminManageStoresRoute;
  '/_authed/_admin/manage/users': typeof AuthedAdminManageUsersRoute;
  '/_authed/_admin/manage/vintages': typeof AuthedAdminManageVintagesRoute;
  '/_authed/_admin/reports/activity-log': typeof AuthedAdminReportsActivityLogRoute;
  '/_authed/_admin/reports/emails': typeof AuthedAdminReportsEmailsRoute;
  '/_authed/_admin/reports/product-search-history': typeof AuthedAdminReportsProductSearchHistoryRoute;
  '/_authed/_admin/reports/products': typeof AuthedAdminReportsProductsRoute;
  '/_authed/_admin/reports/supportRequests': typeof AuthedAdminReportsSupportRequestsRoute;
  '/_authed/_admin/reports/users': typeof AuthedAdminReportsUsersRoute;
  '/_authed/cart/_steps/products': typeof AuthedCartStepsProductsRoute;
  '/_authed/cart/_steps/quantities': typeof AuthedCartStepsQuantitiesRoute;
  '/_authed/cart/_steps/stores': typeof AuthedCartStepsStoresRoute;
  '/_authed/cart/_steps/submit': typeof AuthedCartStepsSubmitRoute;
  '/_authed/cart/confirmation/$salesOrderNumber': typeof AuthedCartConfirmationSalesOrderNumberRoute;
  '/_authed/orders/recurring_/$id': typeof AuthedOrdersRecurringIdRoute;
  '/_authed/orders/recurring_/add': typeof AuthedOrdersRecurringAddRoute;
  '/_authed/store-events/$storeEventId/shipment-report': typeof AuthedStoreEventsStoreEventIdShipmentReportRoute;
  '/_authed/store-events/_steps/$storeEventId': typeof AuthedStoreEventsStepsStoreEventIdRouteWithChildren;
  '/_authed/store-events/_steps/new': typeof AuthedStoreEventsStepsNewRoute;
  '/_authed/stores_/$storeCode/budget': typeof AuthedStoresStoreCodeBudgetRoute;
  '/_authed/_admin/approvals/orders_/$poNumber': typeof AuthedAdminApprovalsOrdersPoNumberRoute;
  '/_authed/_admin/content/announcements_/$announcementId': typeof AuthedAdminContentAnnouncementsAnnouncementIdRoute;
  '/_authed/_admin/content/announcements_/add': typeof AuthedAdminContentAnnouncementsAddRoute;
  '/_authed/_admin/content/faq_/$faqId': typeof AuthedAdminContentFaqFaqIdRoute;
  '/_authed/_admin/content/faq_/add': typeof AuthedAdminContentFaqAddRoute;
  '/_authed/_admin/content/file-manager_/detail': typeof AuthedAdminContentFileManagerDetailRoute;
  '/_authed/_admin/content/file-manager_/upload': typeof AuthedAdminContentFileManagerUploadRoute;
  '/_authed/_admin/manage/calendars_/$fiscalYear': typeof AuthedAdminManageCalendarsFiscalYearRoute;
  '/_authed/_admin/manage/calendars_/add': typeof AuthedAdminManageCalendarsAddRoute;
  '/_authed/_admin/manage/categories_/$categoryId': typeof AuthedAdminManageCategoriesCategoryIdRoute;
  '/_authed/_admin/manage/categories_/add': typeof AuthedAdminManageCategoriesAddRoute;
  '/_authed/_admin/manage/keywords_/$keywordId': typeof AuthedAdminManageKeywordsKeywordIdRoute;
  '/_authed/_admin/manage/keywords_/add': typeof AuthedAdminManageKeywordsAddRoute;
  '/_authed/_admin/manage/markets_/$marketId': typeof AuthedAdminManageMarketsMarketIdRoute;
  '/_authed/_admin/manage/markets_/add': typeof AuthedAdminManageMarketsAddRoute;
  '/_authed/_admin/manage/plants_/$warehouseLocationId': typeof AuthedAdminManagePlantsWarehouseLocationIdRoute;
  '/_authed/_admin/manage/products_/$itemId': typeof AuthedAdminManageProductsItemIdRoute;
  '/_authed/_admin/manage/products_/add': typeof AuthedAdminManageProductsAddRoute;
  '/_authed/_admin/manage/queue-message_/$messageId': typeof AuthedAdminManageQueueMessageMessageIdRoute;
  '/_authed/_admin/manage/stores_/$storeCode': typeof AuthedAdminManageStoresStoreCodeRoute;
  '/_authed/_admin/manage/stores_/add': typeof AuthedAdminManageStoresAddRoute;
  '/_authed/_admin/manage/users_/$userName': typeof AuthedAdminManageUsersUserNameRoute;
  '/_authed/_admin/manage/users_/add': typeof AuthedAdminManageUsersAddRoute;
  '/_authed/_admin/manage/vintages_/$vintageId': typeof AuthedAdminManageVintagesVintageIdRoute;
  '/_authed/_admin/manage/vintages_/add': typeof AuthedAdminManageVintagesAddRoute;
  '/_authed/_admin/reports/emails_/$emailId': typeof AuthedAdminReportsEmailsEmailIdRoute;
  '/_authed/store-events/_steps/$storeEventId/categories': typeof AuthedStoreEventsStepsStoreEventIdCategoriesRoute;
  '/_authed/store-events/_steps/$storeEventId/details': typeof AuthedStoreEventsStepsStoreEventIdDetailsRoute;
  '/_authed/store-events/_steps/$storeEventId/products': typeof AuthedStoreEventsStepsStoreEventIdProductsRoute;
  '/_authed/store-events/_steps_/$storeEventId/': typeof AuthedStoreEventsStepsStoreEventIdIndexRoute;
  '/_authed/_admin/manage/queue-message_/$queue_/$status': typeof AuthedAdminManageQueueMessageQueueStatusRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/store-events'
    | '/not-found'
    | '/first-login'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/privacy'
    | '/reset-password'
    | '/session-expired'
    | '/fulfillment'
    | '/help'
    | '/profile'
    | '/first-login/form'
    | '/reset-password/form'
    | '/manage'
    | '/cart'
    | '/fulfillment/add'
    | '/orders/$poNumber'
    | '/orders/recurring'
    | '/orders/search'
    | '/reports/backorders'
    | '/reports/budgets'
    | '/cart/'
    | '/store-events/'
    | '/approvals/orders'
    | '/content/announcements'
    | '/content/faq'
    | '/content/file-manager'
    | '/distro/history'
    | '/manage/calendars'
    | '/manage/categories'
    | '/manage/featured-products'
    | '/manage/keywords'
    | '/manage/markets'
    | '/manage/plants'
    | '/manage/products'
    | '/manage/queue-message'
    | '/manage/stores'
    | '/manage/users'
    | '/manage/vintages'
    | '/reports/activity-log'
    | '/reports/emails'
    | '/reports/product-search-history'
    | '/reports/products'
    | '/reports/supportRequests'
    | '/reports/users'
    | '/cart/products'
    | '/cart/quantities'
    | '/cart/stores'
    | '/cart/submit'
    | '/cart/confirmation/$salesOrderNumber'
    | '/orders/recurring/$id'
    | '/orders/recurring/add'
    | '/store-events/$storeEventId/shipment-report'
    | '/store-events/$storeEventId'
    | '/store-events/new'
    | '/stores/$storeCode/budget'
    | '/approvals/orders/$poNumber'
    | '/content/announcements/$announcementId'
    | '/content/announcements/add'
    | '/content/faq/$faqId'
    | '/content/faq/add'
    | '/content/file-manager/detail'
    | '/content/file-manager/upload'
    | '/manage/calendars/$fiscalYear'
    | '/manage/calendars/add'
    | '/manage/categories/$categoryId'
    | '/manage/categories/add'
    | '/manage/keywords/$keywordId'
    | '/manage/keywords/add'
    | '/manage/markets/$marketId'
    | '/manage/markets/add'
    | '/manage/plants/$warehouseLocationId'
    | '/manage/products/$itemId'
    | '/manage/products/add'
    | '/manage/queue-message/$messageId'
    | '/manage/stores/$storeCode'
    | '/manage/stores/add'
    | '/manage/users/$userName'
    | '/manage/users/add'
    | '/manage/vintages/$vintageId'
    | '/manage/vintages/add'
    | '/reports/emails/$emailId'
    | '/store-events/$storeEventId/categories'
    | '/store-events/$storeEventId/details'
    | '/store-events/$storeEventId/products'
    | '/store-events/$storeEventId/'
    | '/manage/queue-message/$queue/$status';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/not-found'
    | '/first-login'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/privacy'
    | '/reset-password'
    | '/session-expired'
    | '/fulfillment'
    | '/help'
    | '/profile'
    | '/first-login/form'
    | '/reset-password/form'
    | '/manage'
    | '/cart'
    | '/fulfillment/add'
    | '/orders/$poNumber'
    | '/orders/recurring'
    | '/orders/search'
    | '/reports/backorders'
    | '/reports/budgets'
    | '/store-events'
    | '/approvals/orders'
    | '/content/announcements'
    | '/content/faq'
    | '/content/file-manager'
    | '/distro/history'
    | '/manage/calendars'
    | '/manage/categories'
    | '/manage/featured-products'
    | '/manage/keywords'
    | '/manage/markets'
    | '/manage/plants'
    | '/manage/products'
    | '/manage/queue-message'
    | '/manage/stores'
    | '/manage/users'
    | '/manage/vintages'
    | '/reports/activity-log'
    | '/reports/emails'
    | '/reports/product-search-history'
    | '/reports/products'
    | '/reports/supportRequests'
    | '/reports/users'
    | '/cart/products'
    | '/cart/quantities'
    | '/cart/stores'
    | '/cart/submit'
    | '/cart/confirmation/$salesOrderNumber'
    | '/orders/recurring/$id'
    | '/orders/recurring/add'
    | '/store-events/$storeEventId/shipment-report'
    | '/store-events/$storeEventId'
    | '/store-events/new'
    | '/stores/$storeCode/budget'
    | '/approvals/orders/$poNumber'
    | '/content/announcements/$announcementId'
    | '/content/announcements/add'
    | '/content/faq/$faqId'
    | '/content/faq/add'
    | '/content/file-manager/detail'
    | '/content/file-manager/upload'
    | '/manage/calendars/$fiscalYear'
    | '/manage/calendars/add'
    | '/manage/categories/$categoryId'
    | '/manage/categories/add'
    | '/manage/keywords/$keywordId'
    | '/manage/keywords/add'
    | '/manage/markets/$marketId'
    | '/manage/markets/add'
    | '/manage/plants/$warehouseLocationId'
    | '/manage/products/$itemId'
    | '/manage/products/add'
    | '/manage/queue-message/$messageId'
    | '/manage/stores/$storeCode'
    | '/manage/stores/add'
    | '/manage/users/$userName'
    | '/manage/users/add'
    | '/manage/vintages/$vintageId'
    | '/manage/vintages/add'
    | '/reports/emails/$emailId'
    | '/store-events/$storeEventId/categories'
    | '/store-events/$storeEventId/details'
    | '/store-events/$storeEventId/products'
    | '/manage/queue-message/$queue/$status';
  id:
    | '__root__'
    | '/_authed'
    | '/_authed/_admin'
    | '/_authed/store-events'
    | '/(errors)/not-found'
    | '/(public)/first-login'
    | '/(public)/forgot-password'
    | '/(public)/login'
    | '/(public)/logout'
    | '/(public)/privacy'
    | '/(public)/reset-password'
    | '/(public)/session-expired'
    | '/_authed/fulfillment'
    | '/_authed/help'
    | '/_authed/profile'
    | '/_authed/'
    | '/(public)/first-login_/form'
    | '/(public)/reset-password_/form'
    | '/_authed/_admin/manage'
    | '/_authed/cart/_steps'
    | '/_authed/fulfillment_/add'
    | '/_authed/orders/$poNumber'
    | '/_authed/orders/recurring'
    | '/_authed/orders/search'
    | '/_authed/reports/backorders'
    | '/_authed/reports/budgets'
    | '/_authed/store-events/_steps'
    | '/_authed/cart/'
    | '/_authed/store-events/'
    | '/_authed/_admin/approvals/orders'
    | '/_authed/_admin/content/announcements'
    | '/_authed/_admin/content/faq'
    | '/_authed/_admin/content/file-manager'
    | '/_authed/_admin/distro/history'
    | '/_authed/_admin/manage/calendars'
    | '/_authed/_admin/manage/categories'
    | '/_authed/_admin/manage/featured-products'
    | '/_authed/_admin/manage/keywords'
    | '/_authed/_admin/manage/markets'
    | '/_authed/_admin/manage/plants'
    | '/_authed/_admin/manage/products'
    | '/_authed/_admin/manage/queue-message'
    | '/_authed/_admin/manage/stores'
    | '/_authed/_admin/manage/users'
    | '/_authed/_admin/manage/vintages'
    | '/_authed/_admin/reports/activity-log'
    | '/_authed/_admin/reports/emails'
    | '/_authed/_admin/reports/product-search-history'
    | '/_authed/_admin/reports/products'
    | '/_authed/_admin/reports/supportRequests'
    | '/_authed/_admin/reports/users'
    | '/_authed/cart/_steps/products'
    | '/_authed/cart/_steps/quantities'
    | '/_authed/cart/_steps/stores'
    | '/_authed/cart/_steps/submit'
    | '/_authed/cart/confirmation/$salesOrderNumber'
    | '/_authed/orders/recurring_/$id'
    | '/_authed/orders/recurring_/add'
    | '/_authed/store-events/$storeEventId/shipment-report'
    | '/_authed/store-events/_steps/$storeEventId'
    | '/_authed/store-events/_steps/new'
    | '/_authed/stores_/$storeCode/budget'
    | '/_authed/_admin/approvals/orders_/$poNumber'
    | '/_authed/_admin/content/announcements_/$announcementId'
    | '/_authed/_admin/content/announcements_/add'
    | '/_authed/_admin/content/faq_/$faqId'
    | '/_authed/_admin/content/faq_/add'
    | '/_authed/_admin/content/file-manager_/detail'
    | '/_authed/_admin/content/file-manager_/upload'
    | '/_authed/_admin/manage/calendars_/$fiscalYear'
    | '/_authed/_admin/manage/calendars_/add'
    | '/_authed/_admin/manage/categories_/$categoryId'
    | '/_authed/_admin/manage/categories_/add'
    | '/_authed/_admin/manage/keywords_/$keywordId'
    | '/_authed/_admin/manage/keywords_/add'
    | '/_authed/_admin/manage/markets_/$marketId'
    | '/_authed/_admin/manage/markets_/add'
    | '/_authed/_admin/manage/plants_/$warehouseLocationId'
    | '/_authed/_admin/manage/products_/$itemId'
    | '/_authed/_admin/manage/products_/add'
    | '/_authed/_admin/manage/queue-message_/$messageId'
    | '/_authed/_admin/manage/stores_/$storeCode'
    | '/_authed/_admin/manage/stores_/add'
    | '/_authed/_admin/manage/users_/$userName'
    | '/_authed/_admin/manage/users_/add'
    | '/_authed/_admin/manage/vintages_/$vintageId'
    | '/_authed/_admin/manage/vintages_/add'
    | '/_authed/_admin/reports/emails_/$emailId'
    | '/_authed/store-events/_steps/$storeEventId/categories'
    | '/_authed/store-events/_steps/$storeEventId/details'
    | '/_authed/store-events/_steps/$storeEventId/products'
    | '/_authed/store-events/_steps_/$storeEventId/'
    | '/_authed/_admin/manage/queue-message_/$queue_/$status';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren;
  errorsNotFoundRoute: typeof errorsNotFoundRoute;
  publicFirstLoginRoute: typeof publicFirstLoginRoute;
  publicForgotPasswordRoute: typeof publicForgotPasswordRoute;
  publicLoginRoute: typeof publicLoginRoute;
  publicLogoutRoute: typeof publicLogoutRoute;
  publicPrivacyRoute: typeof publicPrivacyRoute;
  publicResetPasswordRoute: typeof publicResetPasswordRoute;
  publicSessionExpiredRoute: typeof publicSessionExpiredRoute;
  publicFirstLoginFormRoute: typeof publicFirstLoginFormRoute;
  publicResetPasswordFormRoute: typeof publicResetPasswordFormRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(errors)/not-found': {
      id: '/(errors)/not-found';
      path: '/not-found';
      fullPath: '/not-found';
      preLoaderRoute: typeof errorsNotFoundRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/first-login': {
      id: '/(public)/first-login';
      path: '/first-login';
      fullPath: '/first-login';
      preLoaderRoute: typeof publicFirstLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/forgot-password': {
      id: '/(public)/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof publicForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/login': {
      id: '/(public)/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof publicLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/logout': {
      id: '/(public)/logout';
      path: '/logout';
      fullPath: '/logout';
      preLoaderRoute: typeof publicLogoutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/privacy': {
      id: '/(public)/privacy';
      path: '/privacy';
      fullPath: '/privacy';
      preLoaderRoute: typeof publicPrivacyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/reset-password': {
      id: '/(public)/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof publicResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/session-expired': {
      id: '/(public)/session-expired';
      path: '/session-expired';
      fullPath: '/session-expired';
      preLoaderRoute: typeof publicSessionExpiredRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed/': {
      id: '/_authed/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthedIndexRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/_admin': {
      id: '/_authed/_admin';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthedAdminRouteRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/fulfillment': {
      id: '/_authed/fulfillment';
      path: '/fulfillment';
      fullPath: '/fulfillment';
      preLoaderRoute: typeof AuthedFulfillmentRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/help': {
      id: '/_authed/help';
      path: '/help';
      fullPath: '/help';
      preLoaderRoute: typeof AuthedHelpRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/profile': {
      id: '/_authed/profile';
      path: '/profile';
      fullPath: '/profile';
      preLoaderRoute: typeof AuthedProfileRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/store-events': {
      id: '/_authed/store-events';
      path: '/store-events';
      fullPath: '/store-events';
      preLoaderRoute: typeof AuthedStoreEventsRouteRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/(public)/first-login_/form': {
      id: '/(public)/first-login_/form';
      path: '/first-login/form';
      fullPath: '/first-login/form';
      preLoaderRoute: typeof publicFirstLoginFormRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(public)/reset-password_/form': {
      id: '/(public)/reset-password_/form';
      path: '/reset-password/form';
      fullPath: '/reset-password/form';
      preLoaderRoute: typeof publicResetPasswordFormRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authed/_admin/manage': {
      id: '/_authed/_admin/manage';
      path: '/manage';
      fullPath: '/manage';
      preLoaderRoute: typeof AuthedAdminManageRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/cart/': {
      id: '/_authed/cart/';
      path: '/cart';
      fullPath: '/cart/';
      preLoaderRoute: typeof AuthedCartIndexRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/cart/_steps': {
      id: '/_authed/cart/_steps';
      path: '/cart';
      fullPath: '/cart';
      preLoaderRoute: typeof AuthedCartStepsRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/fulfillment_/add': {
      id: '/_authed/fulfillment_/add';
      path: '/fulfillment/add';
      fullPath: '/fulfillment/add';
      preLoaderRoute: typeof AuthedFulfillmentAddRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/orders/$poNumber': {
      id: '/_authed/orders/$poNumber';
      path: '/orders/$poNumber';
      fullPath: '/orders/$poNumber';
      preLoaderRoute: typeof AuthedOrdersPoNumberRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/orders/recurring': {
      id: '/_authed/orders/recurring';
      path: '/orders/recurring';
      fullPath: '/orders/recurring';
      preLoaderRoute: typeof AuthedOrdersRecurringRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/orders/search': {
      id: '/_authed/orders/search';
      path: '/orders/search';
      fullPath: '/orders/search';
      preLoaderRoute: typeof AuthedOrdersSearchRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/reports/backorders': {
      id: '/_authed/reports/backorders';
      path: '/reports/backorders';
      fullPath: '/reports/backorders';
      preLoaderRoute: typeof AuthedReportsBackordersRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/reports/budgets': {
      id: '/_authed/reports/budgets';
      path: '/reports/budgets';
      fullPath: '/reports/budgets';
      preLoaderRoute: typeof AuthedReportsBudgetsRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/store-events/': {
      id: '/_authed/store-events/';
      path: '/';
      fullPath: '/store-events/';
      preLoaderRoute: typeof AuthedStoreEventsIndexRouteImport;
      parentRoute: typeof AuthedStoreEventsRouteRoute;
    };
    '/_authed/store-events/_steps': {
      id: '/_authed/store-events/_steps';
      path: '';
      fullPath: '/store-events';
      preLoaderRoute: typeof AuthedStoreEventsStepsRouteImport;
      parentRoute: typeof AuthedStoreEventsRouteRoute;
    };
    '/_authed/_admin/approvals/orders': {
      id: '/_authed/_admin/approvals/orders';
      path: '/approvals/orders';
      fullPath: '/approvals/orders';
      preLoaderRoute: typeof AuthedAdminApprovalsOrdersRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/announcements': {
      id: '/_authed/_admin/content/announcements';
      path: '/content/announcements';
      fullPath: '/content/announcements';
      preLoaderRoute: typeof AuthedAdminContentAnnouncementsRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/faq': {
      id: '/_authed/_admin/content/faq';
      path: '/content/faq';
      fullPath: '/content/faq';
      preLoaderRoute: typeof AuthedAdminContentFaqRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/file-manager': {
      id: '/_authed/_admin/content/file-manager';
      path: '/content/file-manager';
      fullPath: '/content/file-manager';
      preLoaderRoute: typeof AuthedAdminContentFileManagerRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/distro/history': {
      id: '/_authed/_admin/distro/history';
      path: '/distro/history';
      fullPath: '/distro/history';
      preLoaderRoute: typeof AuthedAdminDistroHistoryRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/manage/calendars': {
      id: '/_authed/_admin/manage/calendars';
      path: '/calendars';
      fullPath: '/manage/calendars';
      preLoaderRoute: typeof AuthedAdminManageCalendarsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/categories': {
      id: '/_authed/_admin/manage/categories';
      path: '/categories';
      fullPath: '/manage/categories';
      preLoaderRoute: typeof AuthedAdminManageCategoriesRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/featured-products': {
      id: '/_authed/_admin/manage/featured-products';
      path: '/featured-products';
      fullPath: '/manage/featured-products';
      preLoaderRoute: typeof AuthedAdminManageFeaturedProductsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/keywords': {
      id: '/_authed/_admin/manage/keywords';
      path: '/keywords';
      fullPath: '/manage/keywords';
      preLoaderRoute: typeof AuthedAdminManageKeywordsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/markets': {
      id: '/_authed/_admin/manage/markets';
      path: '/markets';
      fullPath: '/manage/markets';
      preLoaderRoute: typeof AuthedAdminManageMarketsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/plants': {
      id: '/_authed/_admin/manage/plants';
      path: '/plants';
      fullPath: '/manage/plants';
      preLoaderRoute: typeof AuthedAdminManagePlantsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/products': {
      id: '/_authed/_admin/manage/products';
      path: '/products';
      fullPath: '/manage/products';
      preLoaderRoute: typeof AuthedAdminManageProductsRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/queue-message': {
      id: '/_authed/_admin/manage/queue-message';
      path: '/queue-message';
      fullPath: '/manage/queue-message';
      preLoaderRoute: typeof AuthedAdminManageQueueMessageRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/stores': {
      id: '/_authed/_admin/manage/stores';
      path: '/stores';
      fullPath: '/manage/stores';
      preLoaderRoute: typeof AuthedAdminManageStoresRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/users': {
      id: '/_authed/_admin/manage/users';
      path: '/users';
      fullPath: '/manage/users';
      preLoaderRoute: typeof AuthedAdminManageUsersRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/vintages': {
      id: '/_authed/_admin/manage/vintages';
      path: '/vintages';
      fullPath: '/manage/vintages';
      preLoaderRoute: typeof AuthedAdminManageVintagesRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/reports/activity-log': {
      id: '/_authed/_admin/reports/activity-log';
      path: '/reports/activity-log';
      fullPath: '/reports/activity-log';
      preLoaderRoute: typeof AuthedAdminReportsActivityLogRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/emails': {
      id: '/_authed/_admin/reports/emails';
      path: '/reports/emails';
      fullPath: '/reports/emails';
      preLoaderRoute: typeof AuthedAdminReportsEmailsRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/product-search-history': {
      id: '/_authed/_admin/reports/product-search-history';
      path: '/reports/product-search-history';
      fullPath: '/reports/product-search-history';
      preLoaderRoute: typeof AuthedAdminReportsProductSearchHistoryRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/products': {
      id: '/_authed/_admin/reports/products';
      path: '/reports/products';
      fullPath: '/reports/products';
      preLoaderRoute: typeof AuthedAdminReportsProductsRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/supportRequests': {
      id: '/_authed/_admin/reports/supportRequests';
      path: '/reports/supportRequests';
      fullPath: '/reports/supportRequests';
      preLoaderRoute: typeof AuthedAdminReportsSupportRequestsRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/reports/users': {
      id: '/_authed/_admin/reports/users';
      path: '/reports/users';
      fullPath: '/reports/users';
      preLoaderRoute: typeof AuthedAdminReportsUsersRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/cart/_steps/products': {
      id: '/_authed/cart/_steps/products';
      path: '/products';
      fullPath: '/cart/products';
      preLoaderRoute: typeof AuthedCartStepsProductsRouteImport;
      parentRoute: typeof AuthedCartStepsRoute;
    };
    '/_authed/cart/_steps/quantities': {
      id: '/_authed/cart/_steps/quantities';
      path: '/quantities';
      fullPath: '/cart/quantities';
      preLoaderRoute: typeof AuthedCartStepsQuantitiesRouteImport;
      parentRoute: typeof AuthedCartStepsRoute;
    };
    '/_authed/cart/_steps/stores': {
      id: '/_authed/cart/_steps/stores';
      path: '/stores';
      fullPath: '/cart/stores';
      preLoaderRoute: typeof AuthedCartStepsStoresRouteImport;
      parentRoute: typeof AuthedCartStepsRoute;
    };
    '/_authed/cart/_steps/submit': {
      id: '/_authed/cart/_steps/submit';
      path: '/submit';
      fullPath: '/cart/submit';
      preLoaderRoute: typeof AuthedCartStepsSubmitRouteImport;
      parentRoute: typeof AuthedCartStepsRoute;
    };
    '/_authed/cart/confirmation/$salesOrderNumber': {
      id: '/_authed/cart/confirmation/$salesOrderNumber';
      path: '/cart/confirmation/$salesOrderNumber';
      fullPath: '/cart/confirmation/$salesOrderNumber';
      preLoaderRoute: typeof AuthedCartConfirmationSalesOrderNumberRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/orders/recurring_/$id': {
      id: '/_authed/orders/recurring_/$id';
      path: '/orders/recurring/$id';
      fullPath: '/orders/recurring/$id';
      preLoaderRoute: typeof AuthedOrdersRecurringIdRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/orders/recurring_/add': {
      id: '/_authed/orders/recurring_/add';
      path: '/orders/recurring/add';
      fullPath: '/orders/recurring/add';
      preLoaderRoute: typeof AuthedOrdersRecurringAddRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/store-events/$storeEventId/shipment-report': {
      id: '/_authed/store-events/$storeEventId/shipment-report';
      path: '/$storeEventId/shipment-report';
      fullPath: '/store-events/$storeEventId/shipment-report';
      preLoaderRoute: typeof AuthedStoreEventsStoreEventIdShipmentReportRouteImport;
      parentRoute: typeof AuthedStoreEventsRouteRoute;
    };
    '/_authed/store-events/_steps/$storeEventId': {
      id: '/_authed/store-events/_steps/$storeEventId';
      path: '/$storeEventId';
      fullPath: '/store-events/$storeEventId';
      preLoaderRoute: typeof AuthedStoreEventsStepsStoreEventIdRouteImport;
      parentRoute: typeof AuthedStoreEventsStepsRoute;
    };
    '/_authed/store-events/_steps/new': {
      id: '/_authed/store-events/_steps/new';
      path: '/new';
      fullPath: '/store-events/new';
      preLoaderRoute: typeof AuthedStoreEventsStepsNewRouteImport;
      parentRoute: typeof AuthedStoreEventsStepsRoute;
    };
    '/_authed/stores_/$storeCode/budget': {
      id: '/_authed/stores_/$storeCode/budget';
      path: '/stores/$storeCode/budget';
      fullPath: '/stores/$storeCode/budget';
      preLoaderRoute: typeof AuthedStoresStoreCodeBudgetRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    '/_authed/_admin/approvals/orders_/$poNumber': {
      id: '/_authed/_admin/approvals/orders_/$poNumber';
      path: '/approvals/orders/$poNumber';
      fullPath: '/approvals/orders/$poNumber';
      preLoaderRoute: typeof AuthedAdminApprovalsOrdersPoNumberRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/announcements_/$announcementId': {
      id: '/_authed/_admin/content/announcements_/$announcementId';
      path: '/content/announcements/$announcementId';
      fullPath: '/content/announcements/$announcementId';
      preLoaderRoute: typeof AuthedAdminContentAnnouncementsAnnouncementIdRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/announcements_/add': {
      id: '/_authed/_admin/content/announcements_/add';
      path: '/content/announcements/add';
      fullPath: '/content/announcements/add';
      preLoaderRoute: typeof AuthedAdminContentAnnouncementsAddRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/faq_/$faqId': {
      id: '/_authed/_admin/content/faq_/$faqId';
      path: '/content/faq/$faqId';
      fullPath: '/content/faq/$faqId';
      preLoaderRoute: typeof AuthedAdminContentFaqFaqIdRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/faq_/add': {
      id: '/_authed/_admin/content/faq_/add';
      path: '/content/faq/add';
      fullPath: '/content/faq/add';
      preLoaderRoute: typeof AuthedAdminContentFaqAddRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/file-manager_/detail': {
      id: '/_authed/_admin/content/file-manager_/detail';
      path: '/content/file-manager/detail';
      fullPath: '/content/file-manager/detail';
      preLoaderRoute: typeof AuthedAdminContentFileManagerDetailRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/content/file-manager_/upload': {
      id: '/_authed/_admin/content/file-manager_/upload';
      path: '/content/file-manager/upload';
      fullPath: '/content/file-manager/upload';
      preLoaderRoute: typeof AuthedAdminContentFileManagerUploadRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/_admin/manage/calendars_/$fiscalYear': {
      id: '/_authed/_admin/manage/calendars_/$fiscalYear';
      path: '/calendars/$fiscalYear';
      fullPath: '/manage/calendars/$fiscalYear';
      preLoaderRoute: typeof AuthedAdminManageCalendarsFiscalYearRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/calendars_/add': {
      id: '/_authed/_admin/manage/calendars_/add';
      path: '/calendars/add';
      fullPath: '/manage/calendars/add';
      preLoaderRoute: typeof AuthedAdminManageCalendarsAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/categories_/$categoryId': {
      id: '/_authed/_admin/manage/categories_/$categoryId';
      path: '/categories/$categoryId';
      fullPath: '/manage/categories/$categoryId';
      preLoaderRoute: typeof AuthedAdminManageCategoriesCategoryIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/categories_/add': {
      id: '/_authed/_admin/manage/categories_/add';
      path: '/categories/add';
      fullPath: '/manage/categories/add';
      preLoaderRoute: typeof AuthedAdminManageCategoriesAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/keywords_/$keywordId': {
      id: '/_authed/_admin/manage/keywords_/$keywordId';
      path: '/keywords/$keywordId';
      fullPath: '/manage/keywords/$keywordId';
      preLoaderRoute: typeof AuthedAdminManageKeywordsKeywordIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/keywords_/add': {
      id: '/_authed/_admin/manage/keywords_/add';
      path: '/keywords/add';
      fullPath: '/manage/keywords/add';
      preLoaderRoute: typeof AuthedAdminManageKeywordsAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/markets_/$marketId': {
      id: '/_authed/_admin/manage/markets_/$marketId';
      path: '/markets/$marketId';
      fullPath: '/manage/markets/$marketId';
      preLoaderRoute: typeof AuthedAdminManageMarketsMarketIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/markets_/add': {
      id: '/_authed/_admin/manage/markets_/add';
      path: '/markets/add';
      fullPath: '/manage/markets/add';
      preLoaderRoute: typeof AuthedAdminManageMarketsAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/plants_/$warehouseLocationId': {
      id: '/_authed/_admin/manage/plants_/$warehouseLocationId';
      path: '/plants/$warehouseLocationId';
      fullPath: '/manage/plants/$warehouseLocationId';
      preLoaderRoute: typeof AuthedAdminManagePlantsWarehouseLocationIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/products_/$itemId': {
      id: '/_authed/_admin/manage/products_/$itemId';
      path: '/products/$itemId';
      fullPath: '/manage/products/$itemId';
      preLoaderRoute: typeof AuthedAdminManageProductsItemIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/products_/add': {
      id: '/_authed/_admin/manage/products_/add';
      path: '/products/add';
      fullPath: '/manage/products/add';
      preLoaderRoute: typeof AuthedAdminManageProductsAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/queue-message_/$messageId': {
      id: '/_authed/_admin/manage/queue-message_/$messageId';
      path: '/queue-message/$messageId';
      fullPath: '/manage/queue-message/$messageId';
      preLoaderRoute: typeof AuthedAdminManageQueueMessageMessageIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/stores_/$storeCode': {
      id: '/_authed/_admin/manage/stores_/$storeCode';
      path: '/stores/$storeCode';
      fullPath: '/manage/stores/$storeCode';
      preLoaderRoute: typeof AuthedAdminManageStoresStoreCodeRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/stores_/add': {
      id: '/_authed/_admin/manage/stores_/add';
      path: '/stores/add';
      fullPath: '/manage/stores/add';
      preLoaderRoute: typeof AuthedAdminManageStoresAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/users_/$userName': {
      id: '/_authed/_admin/manage/users_/$userName';
      path: '/users/$userName';
      fullPath: '/manage/users/$userName';
      preLoaderRoute: typeof AuthedAdminManageUsersUserNameRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/users_/add': {
      id: '/_authed/_admin/manage/users_/add';
      path: '/users/add';
      fullPath: '/manage/users/add';
      preLoaderRoute: typeof AuthedAdminManageUsersAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/vintages_/$vintageId': {
      id: '/_authed/_admin/manage/vintages_/$vintageId';
      path: '/vintages/$vintageId';
      fullPath: '/manage/vintages/$vintageId';
      preLoaderRoute: typeof AuthedAdminManageVintagesVintageIdRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/manage/vintages_/add': {
      id: '/_authed/_admin/manage/vintages_/add';
      path: '/vintages/add';
      fullPath: '/manage/vintages/add';
      preLoaderRoute: typeof AuthedAdminManageVintagesAddRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
    '/_authed/_admin/reports/emails_/$emailId': {
      id: '/_authed/_admin/reports/emails_/$emailId';
      path: '/reports/emails/$emailId';
      fullPath: '/reports/emails/$emailId';
      preLoaderRoute: typeof AuthedAdminReportsEmailsEmailIdRouteImport;
      parentRoute: typeof AuthedAdminRouteRoute;
    };
    '/_authed/store-events/_steps/$storeEventId/categories': {
      id: '/_authed/store-events/_steps/$storeEventId/categories';
      path: '/categories';
      fullPath: '/store-events/$storeEventId/categories';
      preLoaderRoute: typeof AuthedStoreEventsStepsStoreEventIdCategoriesRouteImport;
      parentRoute: typeof AuthedStoreEventsStepsStoreEventIdRoute;
    };
    '/_authed/store-events/_steps/$storeEventId/details': {
      id: '/_authed/store-events/_steps/$storeEventId/details';
      path: '/details';
      fullPath: '/store-events/$storeEventId/details';
      preLoaderRoute: typeof AuthedStoreEventsStepsStoreEventIdDetailsRouteImport;
      parentRoute: typeof AuthedStoreEventsStepsStoreEventIdRoute;
    };
    '/_authed/store-events/_steps/$storeEventId/products': {
      id: '/_authed/store-events/_steps/$storeEventId/products';
      path: '/products';
      fullPath: '/store-events/$storeEventId/products';
      preLoaderRoute: typeof AuthedStoreEventsStepsStoreEventIdProductsRouteImport;
      parentRoute: typeof AuthedStoreEventsStepsStoreEventIdRoute;
    };
    '/_authed/store-events/_steps_/$storeEventId/': {
      id: '/_authed/store-events/_steps_/$storeEventId/';
      path: '/$storeEventId';
      fullPath: '/store-events/$storeEventId/';
      preLoaderRoute: typeof AuthedStoreEventsStepsStoreEventIdIndexRouteImport;
      parentRoute: typeof AuthedStoreEventsRouteRoute;
    };
    '/_authed/_admin/manage/queue-message_/$queue_/$status': {
      id: '/_authed/_admin/manage/queue-message_/$queue_/$status';
      path: '/queue-message/$queue/$status';
      fullPath: '/manage/queue-message/$queue/$status';
      preLoaderRoute: typeof AuthedAdminManageQueueMessageQueueStatusRouteImport;
      parentRoute: typeof AuthedAdminManageRoute;
    };
  }
}

interface AuthedAdminManageRouteChildren {
  AuthedAdminManageCalendarsRoute: typeof AuthedAdminManageCalendarsRoute;
  AuthedAdminManageCategoriesRoute: typeof AuthedAdminManageCategoriesRoute;
  AuthedAdminManageFeaturedProductsRoute: typeof AuthedAdminManageFeaturedProductsRoute;
  AuthedAdminManageKeywordsRoute: typeof AuthedAdminManageKeywordsRoute;
  AuthedAdminManageMarketsRoute: typeof AuthedAdminManageMarketsRoute;
  AuthedAdminManagePlantsRoute: typeof AuthedAdminManagePlantsRoute;
  AuthedAdminManageProductsRoute: typeof AuthedAdminManageProductsRoute;
  AuthedAdminManageQueueMessageRoute: typeof AuthedAdminManageQueueMessageRoute;
  AuthedAdminManageStoresRoute: typeof AuthedAdminManageStoresRoute;
  AuthedAdminManageUsersRoute: typeof AuthedAdminManageUsersRoute;
  AuthedAdminManageVintagesRoute: typeof AuthedAdminManageVintagesRoute;
  AuthedAdminManageCalendarsFiscalYearRoute: typeof AuthedAdminManageCalendarsFiscalYearRoute;
  AuthedAdminManageCalendarsAddRoute: typeof AuthedAdminManageCalendarsAddRoute;
  AuthedAdminManageCategoriesCategoryIdRoute: typeof AuthedAdminManageCategoriesCategoryIdRoute;
  AuthedAdminManageCategoriesAddRoute: typeof AuthedAdminManageCategoriesAddRoute;
  AuthedAdminManageKeywordsKeywordIdRoute: typeof AuthedAdminManageKeywordsKeywordIdRoute;
  AuthedAdminManageKeywordsAddRoute: typeof AuthedAdminManageKeywordsAddRoute;
  AuthedAdminManageMarketsMarketIdRoute: typeof AuthedAdminManageMarketsMarketIdRoute;
  AuthedAdminManageMarketsAddRoute: typeof AuthedAdminManageMarketsAddRoute;
  AuthedAdminManagePlantsWarehouseLocationIdRoute: typeof AuthedAdminManagePlantsWarehouseLocationIdRoute;
  AuthedAdminManageProductsItemIdRoute: typeof AuthedAdminManageProductsItemIdRoute;
  AuthedAdminManageProductsAddRoute: typeof AuthedAdminManageProductsAddRoute;
  AuthedAdminManageQueueMessageMessageIdRoute: typeof AuthedAdminManageQueueMessageMessageIdRoute;
  AuthedAdminManageStoresStoreCodeRoute: typeof AuthedAdminManageStoresStoreCodeRoute;
  AuthedAdminManageStoresAddRoute: typeof AuthedAdminManageStoresAddRoute;
  AuthedAdminManageUsersUserNameRoute: typeof AuthedAdminManageUsersUserNameRoute;
  AuthedAdminManageUsersAddRoute: typeof AuthedAdminManageUsersAddRoute;
  AuthedAdminManageVintagesVintageIdRoute: typeof AuthedAdminManageVintagesVintageIdRoute;
  AuthedAdminManageVintagesAddRoute: typeof AuthedAdminManageVintagesAddRoute;
  AuthedAdminManageQueueMessageQueueStatusRoute: typeof AuthedAdminManageQueueMessageQueueStatusRoute;
}

const AuthedAdminManageRouteChildren: AuthedAdminManageRouteChildren = {
  AuthedAdminManageCalendarsRoute: AuthedAdminManageCalendarsRoute,
  AuthedAdminManageCategoriesRoute: AuthedAdminManageCategoriesRoute,
  AuthedAdminManageFeaturedProductsRoute:
    AuthedAdminManageFeaturedProductsRoute,
  AuthedAdminManageKeywordsRoute: AuthedAdminManageKeywordsRoute,
  AuthedAdminManageMarketsRoute: AuthedAdminManageMarketsRoute,
  AuthedAdminManagePlantsRoute: AuthedAdminManagePlantsRoute,
  AuthedAdminManageProductsRoute: AuthedAdminManageProductsRoute,
  AuthedAdminManageQueueMessageRoute: AuthedAdminManageQueueMessageRoute,
  AuthedAdminManageStoresRoute: AuthedAdminManageStoresRoute,
  AuthedAdminManageUsersRoute: AuthedAdminManageUsersRoute,
  AuthedAdminManageVintagesRoute: AuthedAdminManageVintagesRoute,
  AuthedAdminManageCalendarsFiscalYearRoute:
    AuthedAdminManageCalendarsFiscalYearRoute,
  AuthedAdminManageCalendarsAddRoute: AuthedAdminManageCalendarsAddRoute,
  AuthedAdminManageCategoriesCategoryIdRoute:
    AuthedAdminManageCategoriesCategoryIdRoute,
  AuthedAdminManageCategoriesAddRoute: AuthedAdminManageCategoriesAddRoute,
  AuthedAdminManageKeywordsKeywordIdRoute:
    AuthedAdminManageKeywordsKeywordIdRoute,
  AuthedAdminManageKeywordsAddRoute: AuthedAdminManageKeywordsAddRoute,
  AuthedAdminManageMarketsMarketIdRoute: AuthedAdminManageMarketsMarketIdRoute,
  AuthedAdminManageMarketsAddRoute: AuthedAdminManageMarketsAddRoute,
  AuthedAdminManagePlantsWarehouseLocationIdRoute:
    AuthedAdminManagePlantsWarehouseLocationIdRoute,
  AuthedAdminManageProductsItemIdRoute: AuthedAdminManageProductsItemIdRoute,
  AuthedAdminManageProductsAddRoute: AuthedAdminManageProductsAddRoute,
  AuthedAdminManageQueueMessageMessageIdRoute:
    AuthedAdminManageQueueMessageMessageIdRoute,
  AuthedAdminManageStoresStoreCodeRoute: AuthedAdminManageStoresStoreCodeRoute,
  AuthedAdminManageStoresAddRoute: AuthedAdminManageStoresAddRoute,
  AuthedAdminManageUsersUserNameRoute: AuthedAdminManageUsersUserNameRoute,
  AuthedAdminManageUsersAddRoute: AuthedAdminManageUsersAddRoute,
  AuthedAdminManageVintagesVintageIdRoute:
    AuthedAdminManageVintagesVintageIdRoute,
  AuthedAdminManageVintagesAddRoute: AuthedAdminManageVintagesAddRoute,
  AuthedAdminManageQueueMessageQueueStatusRoute:
    AuthedAdminManageQueueMessageQueueStatusRoute,
};

const AuthedAdminManageRouteWithChildren =
  AuthedAdminManageRoute._addFileChildren(AuthedAdminManageRouteChildren);

interface AuthedAdminRouteRouteChildren {
  AuthedAdminManageRoute: typeof AuthedAdminManageRouteWithChildren;
  AuthedAdminApprovalsOrdersRoute: typeof AuthedAdminApprovalsOrdersRoute;
  AuthedAdminContentAnnouncementsRoute: typeof AuthedAdminContentAnnouncementsRoute;
  AuthedAdminContentFaqRoute: typeof AuthedAdminContentFaqRoute;
  AuthedAdminContentFileManagerRoute: typeof AuthedAdminContentFileManagerRoute;
  AuthedAdminDistroHistoryRoute: typeof AuthedAdminDistroHistoryRoute;
  AuthedAdminReportsActivityLogRoute: typeof AuthedAdminReportsActivityLogRoute;
  AuthedAdminReportsEmailsRoute: typeof AuthedAdminReportsEmailsRoute;
  AuthedAdminReportsProductSearchHistoryRoute: typeof AuthedAdminReportsProductSearchHistoryRoute;
  AuthedAdminReportsProductsRoute: typeof AuthedAdminReportsProductsRoute;
  AuthedAdminReportsSupportRequestsRoute: typeof AuthedAdminReportsSupportRequestsRoute;
  AuthedAdminReportsUsersRoute: typeof AuthedAdminReportsUsersRoute;
  AuthedAdminApprovalsOrdersPoNumberRoute: typeof AuthedAdminApprovalsOrdersPoNumberRoute;
  AuthedAdminContentAnnouncementsAnnouncementIdRoute: typeof AuthedAdminContentAnnouncementsAnnouncementIdRoute;
  AuthedAdminContentAnnouncementsAddRoute: typeof AuthedAdminContentAnnouncementsAddRoute;
  AuthedAdminContentFaqFaqIdRoute: typeof AuthedAdminContentFaqFaqIdRoute;
  AuthedAdminContentFaqAddRoute: typeof AuthedAdminContentFaqAddRoute;
  AuthedAdminContentFileManagerDetailRoute: typeof AuthedAdminContentFileManagerDetailRoute;
  AuthedAdminContentFileManagerUploadRoute: typeof AuthedAdminContentFileManagerUploadRoute;
  AuthedAdminReportsEmailsEmailIdRoute: typeof AuthedAdminReportsEmailsEmailIdRoute;
}

const AuthedAdminRouteRouteChildren: AuthedAdminRouteRouteChildren = {
  AuthedAdminManageRoute: AuthedAdminManageRouteWithChildren,
  AuthedAdminApprovalsOrdersRoute: AuthedAdminApprovalsOrdersRoute,
  AuthedAdminContentAnnouncementsRoute: AuthedAdminContentAnnouncementsRoute,
  AuthedAdminContentFaqRoute: AuthedAdminContentFaqRoute,
  AuthedAdminContentFileManagerRoute: AuthedAdminContentFileManagerRoute,
  AuthedAdminDistroHistoryRoute: AuthedAdminDistroHistoryRoute,
  AuthedAdminReportsActivityLogRoute: AuthedAdminReportsActivityLogRoute,
  AuthedAdminReportsEmailsRoute: AuthedAdminReportsEmailsRoute,
  AuthedAdminReportsProductSearchHistoryRoute:
    AuthedAdminReportsProductSearchHistoryRoute,
  AuthedAdminReportsProductsRoute: AuthedAdminReportsProductsRoute,
  AuthedAdminReportsSupportRequestsRoute:
    AuthedAdminReportsSupportRequestsRoute,
  AuthedAdminReportsUsersRoute: AuthedAdminReportsUsersRoute,
  AuthedAdminApprovalsOrdersPoNumberRoute:
    AuthedAdminApprovalsOrdersPoNumberRoute,
  AuthedAdminContentAnnouncementsAnnouncementIdRoute:
    AuthedAdminContentAnnouncementsAnnouncementIdRoute,
  AuthedAdminContentAnnouncementsAddRoute:
    AuthedAdminContentAnnouncementsAddRoute,
  AuthedAdminContentFaqFaqIdRoute: AuthedAdminContentFaqFaqIdRoute,
  AuthedAdminContentFaqAddRoute: AuthedAdminContentFaqAddRoute,
  AuthedAdminContentFileManagerDetailRoute:
    AuthedAdminContentFileManagerDetailRoute,
  AuthedAdminContentFileManagerUploadRoute:
    AuthedAdminContentFileManagerUploadRoute,
  AuthedAdminReportsEmailsEmailIdRoute: AuthedAdminReportsEmailsEmailIdRoute,
};

const AuthedAdminRouteRouteWithChildren =
  AuthedAdminRouteRoute._addFileChildren(AuthedAdminRouteRouteChildren);

interface AuthedStoreEventsStepsStoreEventIdRouteChildren {
  AuthedStoreEventsStepsStoreEventIdCategoriesRoute: typeof AuthedStoreEventsStepsStoreEventIdCategoriesRoute;
  AuthedStoreEventsStepsStoreEventIdDetailsRoute: typeof AuthedStoreEventsStepsStoreEventIdDetailsRoute;
  AuthedStoreEventsStepsStoreEventIdProductsRoute: typeof AuthedStoreEventsStepsStoreEventIdProductsRoute;
}

const AuthedStoreEventsStepsStoreEventIdRouteChildren: AuthedStoreEventsStepsStoreEventIdRouteChildren =
  {
    AuthedStoreEventsStepsStoreEventIdCategoriesRoute:
      AuthedStoreEventsStepsStoreEventIdCategoriesRoute,
    AuthedStoreEventsStepsStoreEventIdDetailsRoute:
      AuthedStoreEventsStepsStoreEventIdDetailsRoute,
    AuthedStoreEventsStepsStoreEventIdProductsRoute:
      AuthedStoreEventsStepsStoreEventIdProductsRoute,
  };

const AuthedStoreEventsStepsStoreEventIdRouteWithChildren =
  AuthedStoreEventsStepsStoreEventIdRoute._addFileChildren(
    AuthedStoreEventsStepsStoreEventIdRouteChildren,
  );

interface AuthedStoreEventsStepsRouteChildren {
  AuthedStoreEventsStepsStoreEventIdRoute: typeof AuthedStoreEventsStepsStoreEventIdRouteWithChildren;
  AuthedStoreEventsStepsNewRoute: typeof AuthedStoreEventsStepsNewRoute;
}

const AuthedStoreEventsStepsRouteChildren: AuthedStoreEventsStepsRouteChildren =
  {
    AuthedStoreEventsStepsStoreEventIdRoute:
      AuthedStoreEventsStepsStoreEventIdRouteWithChildren,
    AuthedStoreEventsStepsNewRoute: AuthedStoreEventsStepsNewRoute,
  };

const AuthedStoreEventsStepsRouteWithChildren =
  AuthedStoreEventsStepsRoute._addFileChildren(
    AuthedStoreEventsStepsRouteChildren,
  );

interface AuthedStoreEventsRouteRouteChildren {
  AuthedStoreEventsStepsRoute: typeof AuthedStoreEventsStepsRouteWithChildren;
  AuthedStoreEventsIndexRoute: typeof AuthedStoreEventsIndexRoute;
  AuthedStoreEventsStoreEventIdShipmentReportRoute: typeof AuthedStoreEventsStoreEventIdShipmentReportRoute;
  AuthedStoreEventsStepsStoreEventIdIndexRoute: typeof AuthedStoreEventsStepsStoreEventIdIndexRoute;
}

const AuthedStoreEventsRouteRouteChildren: AuthedStoreEventsRouteRouteChildren =
  {
    AuthedStoreEventsStepsRoute: AuthedStoreEventsStepsRouteWithChildren,
    AuthedStoreEventsIndexRoute: AuthedStoreEventsIndexRoute,
    AuthedStoreEventsStoreEventIdShipmentReportRoute:
      AuthedStoreEventsStoreEventIdShipmentReportRoute,
    AuthedStoreEventsStepsStoreEventIdIndexRoute:
      AuthedStoreEventsStepsStoreEventIdIndexRoute,
  };

const AuthedStoreEventsRouteRouteWithChildren =
  AuthedStoreEventsRouteRoute._addFileChildren(
    AuthedStoreEventsRouteRouteChildren,
  );

interface AuthedCartStepsRouteChildren {
  AuthedCartStepsProductsRoute: typeof AuthedCartStepsProductsRoute;
  AuthedCartStepsQuantitiesRoute: typeof AuthedCartStepsQuantitiesRoute;
  AuthedCartStepsStoresRoute: typeof AuthedCartStepsStoresRoute;
  AuthedCartStepsSubmitRoute: typeof AuthedCartStepsSubmitRoute;
}

const AuthedCartStepsRouteChildren: AuthedCartStepsRouteChildren = {
  AuthedCartStepsProductsRoute: AuthedCartStepsProductsRoute,
  AuthedCartStepsQuantitiesRoute: AuthedCartStepsQuantitiesRoute,
  AuthedCartStepsStoresRoute: AuthedCartStepsStoresRoute,
  AuthedCartStepsSubmitRoute: AuthedCartStepsSubmitRoute,
};

const AuthedCartStepsRouteWithChildren = AuthedCartStepsRoute._addFileChildren(
  AuthedCartStepsRouteChildren,
);

interface AuthedRouteRouteChildren {
  AuthedAdminRouteRoute: typeof AuthedAdminRouteRouteWithChildren;
  AuthedStoreEventsRouteRoute: typeof AuthedStoreEventsRouteRouteWithChildren;
  AuthedFulfillmentRoute: typeof AuthedFulfillmentRoute;
  AuthedHelpRoute: typeof AuthedHelpRoute;
  AuthedProfileRoute: typeof AuthedProfileRoute;
  AuthedIndexRoute: typeof AuthedIndexRoute;
  AuthedCartStepsRoute: typeof AuthedCartStepsRouteWithChildren;
  AuthedFulfillmentAddRoute: typeof AuthedFulfillmentAddRoute;
  AuthedOrdersPoNumberRoute: typeof AuthedOrdersPoNumberRoute;
  AuthedOrdersRecurringRoute: typeof AuthedOrdersRecurringRoute;
  AuthedOrdersSearchRoute: typeof AuthedOrdersSearchRoute;
  AuthedReportsBackordersRoute: typeof AuthedReportsBackordersRoute;
  AuthedReportsBudgetsRoute: typeof AuthedReportsBudgetsRoute;
  AuthedCartIndexRoute: typeof AuthedCartIndexRoute;
  AuthedCartConfirmationSalesOrderNumberRoute: typeof AuthedCartConfirmationSalesOrderNumberRoute;
  AuthedOrdersRecurringIdRoute: typeof AuthedOrdersRecurringIdRoute;
  AuthedOrdersRecurringAddRoute: typeof AuthedOrdersRecurringAddRoute;
  AuthedStoresStoreCodeBudgetRoute: typeof AuthedStoresStoreCodeBudgetRoute;
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedAdminRouteRoute: AuthedAdminRouteRouteWithChildren,
  AuthedStoreEventsRouteRoute: AuthedStoreEventsRouteRouteWithChildren,
  AuthedFulfillmentRoute: AuthedFulfillmentRoute,
  AuthedHelpRoute: AuthedHelpRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedCartStepsRoute: AuthedCartStepsRouteWithChildren,
  AuthedFulfillmentAddRoute: AuthedFulfillmentAddRoute,
  AuthedOrdersPoNumberRoute: AuthedOrdersPoNumberRoute,
  AuthedOrdersRecurringRoute: AuthedOrdersRecurringRoute,
  AuthedOrdersSearchRoute: AuthedOrdersSearchRoute,
  AuthedReportsBackordersRoute: AuthedReportsBackordersRoute,
  AuthedReportsBudgetsRoute: AuthedReportsBudgetsRoute,
  AuthedCartIndexRoute: AuthedCartIndexRoute,
  AuthedCartConfirmationSalesOrderNumberRoute:
    AuthedCartConfirmationSalesOrderNumberRoute,
  AuthedOrdersRecurringIdRoute: AuthedOrdersRecurringIdRoute,
  AuthedOrdersRecurringAddRoute: AuthedOrdersRecurringAddRoute,
  AuthedStoresStoreCodeBudgetRoute: AuthedStoresStoreCodeBudgetRoute,
};

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  errorsNotFoundRoute: errorsNotFoundRoute,
  publicFirstLoginRoute: publicFirstLoginRoute,
  publicForgotPasswordRoute: publicForgotPasswordRoute,
  publicLoginRoute: publicLoginRoute,
  publicLogoutRoute: publicLogoutRoute,
  publicPrivacyRoute: publicPrivacyRoute,
  publicResetPasswordRoute: publicResetPasswordRoute,
  publicSessionExpiredRoute: publicSessionExpiredRoute,
  publicFirstLoginFormRoute: publicFirstLoginFormRoute,
  publicResetPasswordFormRoute: publicResetPasswordFormRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
